import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppArcComponent} from "../app-arc/app-arc.component";
import {AppLogComponent} from "../app-log/app-log.component";
import {AppTasksComponent} from '../app-tasks/app-tasks.component';
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {RecordDataComponent} from "../record-data/record-data.component";
import {ItemService} from "../../services/item.service";
import {TranslateService} from "@ngx-translate/core";
import {SharedService} from "../../services";
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-show-buttons',
  templateUrl: './show-buttons.component.html',
  styleUrls: ['./show-buttons.component.scss'],
  providers:[ItemService]
})
export class ShowButtonsComponent implements OnInit, AfterViewInit {
  @Input() refShow;
  @Input() modelName;
  @Output() update_event = new EventEmitter();

  public userRoles: any[]=[];
  public systemName = '';
  public userid = 0;

  @Input('ShowItem') ShowItem:any;

  @Input() rowId:string = '';
  @Input() newData;
  @Input() newDatap = true;
  @Input() newDatad;
  //@Input() ShowItem;

private _transButton:any;

  constructor(private modalService: NgbModal,
              private itemService: ItemService,
              private sharedservice: SharedService,
              public translate: TranslateService,) {
    this.refShow = this.sharedservice.getItemShow();
    this.modelName = this.sharedservice.getModelName();
    this.itemService.urlString = this.sharedservice.getModelName();

  }

  ngOnInit() {
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if (userdata) {
      this.userRoles = userdata.roles.description;
      this.systemName = userdata.systems[0];
      this.userid = userdata.id;
    }

  }

  ngAfterViewInit() {
    this._transButton = document.getElementById('transButton');
    Observable.interval(2000).take(5).subscribe(x => { // will execute every 30 seconds
      this.sharedservice.setItem(this.ShowItem);
    });
  }

  showHistory() {
    this.newDatap = true;
    if(this.rowId){
      if(this.newDatap){
        const modalRef = this.modalService.open(AppLogComponent);
        modalRef.componentInstance.refShow = this.refShow;
        modalRef.componentInstance.rowId = this.rowId;
        modalRef.componentInstance.newDatad = this.newDatad;
        modalRef.componentInstance.newDatap  = !this.newDatap;
      }
    }
  }

  showTasks() {
    this.newDatap = true;
    if(this.rowId) {
      const modalRef = this.modalService.open(AppTasksComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.rowId = this.rowId;
    }
  }

  showattachement() {
    if (this.rowId) {
      const modalRef = this.modalService.open(AppArcComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.rowId = this.rowId;
      if(this.newData){
        modalRef.componentInstance.allowaction = false;
      }

      modalRef.componentInstance.screenName = this.modelName;
    }
  }

  recordData() {
    console.log(this.ShowItem);
    //console.log(this.ShowItem);
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        // this.changePicUrl();
        return true;
      }
    };
    const modalRef = this.modalService.open(RecordDataComponent,options);
    modalRef.componentInstance.refRec = this.ShowItem;
    modalRef.componentInstance.rowId = '';

  }

  permissionAllow(button:string):boolean {

    let role:string = '';
    switch(button) {
      case 'newButton': {
        role = 'create';
        break;
      }
      case 'saveButton': {
        role = 'update';
        break;
      }
      case 'deleteButton': {
        role = 'delete';
        break;
      }
      case 'searchButton': {
        role = 'search';
        break;
      }
      case 'excelButton': {
        role = 'excel';
        break;
      }
      case 'printButton': {
        role = 'print';
        break;
      }
      case 'historyButton': {
        role = 'history';
        break;
      }
      case 'restoreButton': {
        role = 'restore';
        break;
      }
      case 'attachmentsButton': {
        role = 'attachments';
        break;
      }
      case 'rowinfo': {
        role = 'rowinfo';
        break;
      }

      default: {
        role = '';
        break;
      }
    }
    let Osystem = 'setting';
    if(localStorage.getItem('OpenSystem')) {
      Osystem = localStorage.getItem('OpenSystem');
    }

    if(this.modelName === 'itemsGroups' ){
      this.modelName = "items_groups";
    }

    if(this.userRoles.indexOf(Osystem+'.'+this.modelName+'.'+role) >= 0 || this.userRoles.indexOf('setting.'+this.modelName+'.'+role) >= 0) {
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/show-buttons/show-buttons.component.ts